"use client";

import { useTranslations } from "next-intl";

export function InboxFilters({ value, onChange, ariaLabel }: {
  value: "all" | "unread";
  onChange: (value: "all" | "unread") => void;
  ariaLabel: string;
}) {
  const t = useTranslations("common.inboxFilters");

  return (
    <div role="group" aria-label={ariaLabel} className="flex shrink-0 gap-2 px-4 pb-2">
      {(["all", "unread"] as const).map((filter) => (
        <button
          key={filter}
          type="button"
          aria-pressed={value === filter}
          onClick={() => onChange(filter)}
          className={`rounded-full px-3.5 py-2 text-sm font-semibold outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary ${value === filter ? "bg-primary/10 text-primary" : "text-text hover:bg-surface-hover"}`}
        >
          {t(filter)}
        </button>
      ))}
    </div>
  );
}
